import produce from 'immer';
import { debounce } from 'lodash';

import type { Entity } from '../entities';
import type { ResultsView } from '../events';
import { resultsView } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';

export const resultsViewed = debounce(
  (context: TrackingContextValue, list: ResultsView, contents?: Entity[]) =>
    resultsView(
      list,
      produce(context, (draft) => {
        draft.entities = draft.entities || [];
        contents && draft.entities.push(...contents);
      })
    ),
  1000
);
